import { Price } from '@product/const';
import { StateUtils } from '@spartacus/core';
import { PRICES } from '../product-state';

export const LOAD_PRICES = '[CustomProduct] Load Prices';
export const SET_PRICES = '[CustomProduct] Set Prices';
export const LOAD_PRICES_SUCCESS = '[CustomProduct] Load Prices Success';
export const LOAD_PRICES_FAIL = '[CustomProduct] Load Prices Fail';
export const RESET_PRICES = '[CustomProduct] Reset Prices';
export const RESET_ALL_PRICES = '[CustomProduct] Reset All Prices';

export class LoadPrices extends StateUtils.EntityLoadAction {
  readonly type = LOAD_PRICES;

  constructor(public productCode: string) {
    super(PRICES, productCode);
  }
}

export class LoadPricesFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_PRICES_FAIL;

  constructor(
    public productCode: string,
    payload: any,
  ) {
    super(PRICES, productCode, payload);
  }
}

export class LoadPricesSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_PRICES_SUCCESS;

  constructor(
    public productCode: string,
    public payload: Price[],
  ) {
    super(PRICES, productCode, payload);
  }
}

export class SetPrices implements StateUtils.EntityAction {
  readonly type = SET_PRICES;
  readonly meta: StateUtils.EntityMeta;

  constructor(
    public productCode: string,
    public payload: Price[],
  ) {
    this.meta = StateUtils.entityMeta(PRICES, productCode);
  }
}

export class ResetPrices extends StateUtils.EntityLoaderResetAction {
  readonly type = RESET_PRICES;

  constructor(productCode: string) {
    super(PRICES, productCode);
  }
}

export class ResetAllPrices extends StateUtils.EntityRemoveAllAction {
  readonly type = RESET_ALL_PRICES;

  constructor() {
    super(PRICES);
  }
}
